/**
 * DemoAccountsBanner displays demo account credentials for testing.
 * Shows two test accounts with their emails and passwords.
 *
 * @returns {React.ReactElement} Demo accounts banner
 */
export default function DemoAccountsBanner() {
  return (
    <div className="demo-banner">
      <div className="demo-banner__header">
        <svg
          className="demo-banner__icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <h2 className="demo-banner__title">Konta testowe</h2>
      </div>
      <p className="demo-banner__description">
        Możesz użyć jednego z poniższych kont testowych:
      </p>
      <div className="demo-banner__accounts">
        <div className="demo-banner__account">
          <div className="demo-banner__credential">
            <span className="demo-banner__label">Email:</span>
            <code className="demo-banner__value">admin1@admin.pl</code>
          </div>
          <div className="demo-banner__credential">
            <span className="demo-banner__label">Hasło:</span>
            <code className="demo-banner__value">admin</code>
          </div>
        </div>
        <div className="demo-banner__account">
          <div className="demo-banner__credential">
            <span className="demo-banner__label">Email:</span>
            <code className="demo-banner__value">admin2@admin.pl</code>
          </div>
          <div className="demo-banner__credential">
            <span className="demo-banner__label">Hasło:</span>
            <code className="demo-banner__value">admin</code>
          </div>
        </div>
      </div>
    </div>
  )
}
